import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


const Naray8BackButton = ({className}) => {
    const navigate = useNavigate();
    return (
        <button
            onClick={() => navigate(-1)}
            className={`flex items-center gap-2 text-customDark transition p-1 bg-white/15 hover:bg-white/10 ${className}`}
        >
            <ArrowBack />
            <span className="text-sm">Go back</span>
        </button>
    );
}

export default Naray8BackButton;